module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/successmodal/successmodal.component.css
// module id = ./src/app/shared/component/successmodal/successmodal.component.css
// module chunks = main